import React from "react";

/** Контент тілдері: RU — міндетті (негізгі), KZ/EN — қалауынша. Пайдаланушы өз құрылғы тілінде көреді. */
export const CONTENT_LANGS = [
  { id: "ru", label: "RU", name: "Русский" },
  { id: "kk", label: "KZ", name: "Қазақша" },
  { id: "en", label: "EN", name: "English" },
];

/**
 * RU / KZ / EN қойындылары. `status[lang]`: "filled" | "partial" | "empty".
 * Толтырылмаған тіл — пайдаланушыға RU нұсқасы көрсетіледі.
 */
const LangTabs = ({ value, onChange, status = {} }) => (
  <div role="tablist" aria-label="Язык текста" className="inline-flex rounded-lg border border-border-primary bg-bg-primary p-0.5">
    {CONTENT_LANGS.map((l) => {
      const active = value === l.id;
      const st = status[l.id] || "empty";
      return (
        <button
          key={l.id}
          type="button"
          role="tab"
          aria-selected={active}
          title={`${l.name}${l.id === "ru" ? " — обязательно" : st === "empty" ? " — не заполнено, покажем RU" : st === "partial" ? " — заполнено не полностью" : ""}`}
          onClick={() => onChange(l.id)}
          className={`flex items-center gap-1.5 rounded-md px-3 py-1 text-xs font-semibold transition-colors ${
            active ? "bg-[#4F45E5] text-white" : "text-text-secondary hover:bg-bg-tertiary"
          }`}
        >
          {l.label}
          {l.id === "ru" && <span className={active ? "text-white/80" : "text-rose-500"}>*</span>}
          {l.id !== "ru" && (
            <span
              aria-hidden="true"
              className={`h-1.5 w-1.5 rounded-full ${st === "filled" ? "bg-emerald-500" : st === "partial" ? "bg-amber-500" : active ? "bg-white/40" : "bg-border-primary"}`}
            />
          )}
        </button>
      );
    })}
  </div>
);

export default LangTabs;
